/**
 * 预计出货订单 - 质检图片检查确认页
 *
 * @author FJJ
 * @version 1.0
 * @Time 2022.07.04
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import {message, Space, Input, Modal, Result, Button,Tooltip} from 'antd';
import Lang from "@components/Lang/Lang";
import { Spin} from "antd";
import {isEmpty} from '@utils/utils';
import { CloseOutlined,AlignLeftOutlined } from '@ant-design/icons';
import "./CheckQualityPictures.less";
import ShipperManagementAction from "../../ShipperManagement.action";
const { Search } = Input;
class CheckQualityPictures extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            collapsed: true, // 显示商品信息
            modalVisible:false, //成功弹窗
            list:[],// 图片列表
            currItem: {}, // 当前项
            currInx:0,
            sKeyWord:'',
        }
    }
    /**
     * 查看详情
     * @iId 订单号
     * @设置当前值
     * @成功后弹出 下一单窗口
     * */
    getDetail(iId='',iCurrInx=0, showSuccess=false){
        if(isEmpty(iId)){
            return
        }
        this.loading(true);
        let postData = {
            containerId:iId,
        }
        const {sKeyWord} =this.state;
        if(!isEmpty(sKeyWord)){
            postData['keyword'] =sKeyWord;
        }
        ShipperManagementAction.getCheckQualityPicList(postData).then(res=>this.handleRes(res.data,iCurrInx,showSuccess)).catch(err=>this.handleRes(err))
    }
    handleRes(res,iCurrInx=0,){
        const {success,valid,models,model} = res;
        if(success&&valid) {
            // const nextTrackId = model && model.nextTrackId; // 下一单可处理ID
            if(models.length>0){
                //更新页面 设置选择
                this.setState({
                    list:models,
                    currItem: models[iCurrInx],
                    currInx: iCurrInx,
                    // nextTrackId:nextTrackId,
                    model:model
                }, ()=>setTimeout(()=>this.loading(false), 400));
            }else this.loading(false);
        }else if(res.message){
                message.warning(res.message);
                this.loading(false);
         } else this.loading(false);
    }

    /**
     * 加载状态
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }

    /**
     * 标记按钮点击 提交事件
     * @iId 当前处理Po单Id
     * @currItem 当前处理项
     * @status 1:正常 2:有问题 1:正常 2:有问题
     * @nextLazyFlag 成功后是否延迟2s进入下一张, false 为成功即加载下一张
     * */
    onClickConfirmGoods(iId,currItem={},sStatus='',nextLazyFlag=false){
        if(isEmpty(iId)||isEmpty(currItem.poItemId)){
            return
        }
        if(currItem.status!=sStatus){//需要更新的
            this.loading(true);
            let postData = {
                containerId:iId, //集柜单Id
                poId: currItem.poId,
                poItemId:currItem.poItemId,
                fileId: currItem.fileId,
                status:sStatus, // 0 正常 1 侵权
            }
            ShipperManagementAction.updateQualityPicListStatu(postData).then(res=>this.handleConfirmRes(res.data,sStatus,nextLazyFlag)).catch(err=>this.handleConfirmRes(err))
        }else { //无更新直接进入下一款
            const {currInx,list} = this.state;
            this.handleSelect(currInx+1,list);
        }

    }
    handleConfirmRes(res,sStatus,nextLazyFlag=false){
        this.loading(false);
        const {success,valid} = res;
        if(success&&valid){
            const {currInx,list} = this.state;
            // 成功后 暂存 列表，不重新请求数据
            let newList = [...list];
            newList[currInx]['status'] = sStatus;
            this.setState({
                list:newList
            },function () {
                //加载 下一张
                if(nextLazyFlag){
                    setTimeout(()=>{
                        message.loading({
                            content: Lang({id:'JinRuXiaYiKuan',default: "进入下一款",}),
                            className: 'custom-class',
                            style: {
                                marginTop: '20vh',
                            },
                            duration:1
                        });
                    },1000)
                    setTimeout(()=>{
                        this.handleSelect(currInx+1,list);
                    },2000)
                }else this.handleSelect(currInx+1,list);
            })
            // this.getDetail(iId,currInx+1,showSuccess);
        }else if(res.message){
            message.warning(res.message);
        } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
    }
    /**
     * 处理上一个下一个
     * @currInx 需要设置的当前项目在列表中的序号
     * @list 列表
     **/
    handleSelect(selectInx=0,list=[]){
        if(selectInx>=0&&selectInx<list.length){
            this.loading(true);
            const newItem = list[selectInx];
            this.setState({
                currItem:newItem,
                currInx:selectInx,
            },()=>{
                setTimeout(()=>this.loading(false),400)
            });
        }else if(selectInx>=list.length){ //下一张 超出列表即 处理完成所有
            this.setModalVisible(true)
        }
    }
    /**
     * 关闭弹窗
     */
    setModalVisible(flag=false){
        this.setState({
            modalVisible:flag
        })
    }
    /**
     * 返回详情
     * */
    backList(){
        this.loading(true);
        const {iId,} = this.state;
        this.setModalVisible();
        setTimeout(()=>{
            this.props.history.push('/shipperManagement/estimatedShippingOrder/detail?'+iId)
            this.loading(false);
        },400);
    }
    //搜索
    onSearch(value){
        this.setState({
            sKeyWord: value
        },  function() {
            const {iId} =this.state;
            this.getDetail(iId)
        })
    }
    /**
     * 来源订单号
     * */
    getCerId(str){
        let iId = str.length>0?str.substr(1,str.length):'';
        iId = iId?Number(iId):'';
        this.setState({
            iId: iId
        })
        return iId;
    }

    // 切换当前项显示
    changeCollapsed(flag){
        this.setState({
            collapsed: flag
        })
    }
    componentDidMount() {
        const { search } = this.props.location;
        const iId = this.getCerId(search);
        this.getDetail(iId,0);
    }
    componentWillUnmount(){
        window.removeEventListener('beforeunload', this.listener)
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const {loading,currItem,list,currInx,iId,collapsed,modalVisible,nextTrackId,model } = this.state;
        const currPageName = Lang({id: "YuJiChuHuoDingDan",default: "预计出货订单"});

        return (<Spin tip='loading' spinning={loading}>
            <CommonBreadcrumb list={[{ name:currPageName,link:'/shipperManagement/estimatedShippingOrder/list'},
                {name:Lang({id: "YuJiChuHuoDingDanXiangQing",default: "预计出货订单详情"}),
                link:'/shipperManagement/estimatedShippingOrder/detail?'+iId},
                {name:Lang({id: "ZhiJianTuPianQueRen",default: "质检图片确认"})}
                ]}></CommonBreadcrumb>
                <div className="checkQualityPicturesStyle">
                    <div className={'content'}>
                        {collapsed?
                        <div className={'left'}>
                            <CloseOutlined className={'btn-close'} onClick={()=>this.changeCollapsed(!collapsed)} />
                            <Space>
                                <img src={currItem.skuFileUrl + "@!100"} />
                                <div>
                                    <p>{currItem.poCode}</p>
                                    <p>{Lang({id: 'ShangPinBianMa', default: '商品编码'})}<span>{currItem.skuNo}</span></p>
                                </div>
                            </Space>
                        </div>:<div className={'left'} onClick={()=>this.changeCollapsed(!collapsed)}>
                                <AlignLeftOutlined className={"btn-menu"} />
                            </div>}
                        <div className={"main"}>
                        {currItem.qualityFileUrl&&currItem.qualityFileUrl.length>0&&<img src={currItem.qualityFileUrl+'@!1200_p100'} alt={currItem.skuNo} title={currItem.skuNo} />}
                        </div>
                    </div>
                    <div className={'footer'}>
                        <Space>
                            <Search size={"large"} placeholder={Lang({id: 'DingDanHao', default: '订单号'})+'/'+Lang({id: 'ShangPinBianHao', default: '商品编号'})}
                                    onSearch={(value)=>this.onSearch(value)}
                                    allowClear={true}
                                    style={{ width: 200 }} />
                                {/* 上一个 */}
                                <span className={currInx-1<0?'btnDisable':'btn'} onClick={()=>this.handleSelect(currInx-1,list)}>{Lang({id:'ShangYiZhang',default:'上一张'})}</span>
                                {/* 下一个 点击默认无标记 1:正常 2:有问题*/}
                                <span className={'btn'}
                                      onClick={()=>this.onClickConfirmGoods(iId,currItem,currItem.status==2?2:1)}
                                >{Lang({id:'XiaYiZhang',default:'下一张'})}</span>
                                {/* 标记  1:正常 2:有问题 */}
                                
                            {currItem.status==2?<Tooltip placement="top" title={Lang({id: 'QuXiaoBiaoJi', default: '取消标记'})}>
                                <span className={'btn btn-red on'} onClick={()=>this.onClickConfirmGoods(iId,currItem,1,true)}>{Lang({id: 'YiBiaoJi', default: '已标记'})}：{Lang({id: 'YouWenTi', default: '有问题'})}</span>
                            </Tooltip>:<span className={'btn btn-red'} onClick={()=>this.onClickConfirmGoods(iId,currItem,2,true)}>
                                    {Lang({id: 'BiaoJiCiShangPin', default: '标记此商品'})}
                                </span>}

                                <span className={'letter-spacing-2'}>{currInx+1}/{list.length}</span>
                        </Space>
                    </div>
                </div>
            {modalVisible&&<Modal
                open={modalVisible}
                footer={null}
                onCancel={()=>this.backList(false)}
            >
                <Result
                    status="success"
                    onCancel={()=>this.backList(false)}
                    title={Lang({id: 'GaiDingDanQuanBuShangPinYiChuLi', default: '该订单全部商品已处理'})}
                    extra={ <Button type="primary" key="console" onClick={()=>this.backList()}>
                        {Lang({id: "FanHui",default: "返回"})}
                    </Button>}
                />
            </Modal>}
        </Spin>)
    }
}
export default CheckQualityPictures;